export enum FeatureName {
  BrowseProfession = 'BrowseProfession',
  CareerPath = 'CareerPath',
  Profile = 'Profile',
  ProfessionPage = 'ProfessionPage',
  DisciplinePage = 'DisciplinePage',
  RoleCard = 'RoleCard',
  RolePage = 'RolePage',
  HomePage = 'HomePage',
  OCVFeedback = 'OCVFeedback',
  AskHr = 'AskHr',
  FAQ = 'FAQ',
}

export enum SubFeatureName {
  BrowseAllCareerPath = 'BrowseAllCareerPath',
  ExpandProfession = 'ExpandProfession',
  OpenDiscipline = 'OpenDiscipline',
  PinCareerStage = 'PinCareerStage',
  ViewCareerStageDetail = 'ViewCareerStageDetail',
  ReadMoreRoleSummary = 'ReadMoreRoleSummary',
  ViewAllRequiredSkills = 'ViewAllRequiredSkills',
  ViewAllInCareerPath = 'ViewAllInCareerPath',
  ViewProfile = 'ViewProfile',
  Bookmark = 'Bookmark',
  TabList = 'TabList',
  SeeMoreAndLess = 'SeeMoreAndLess',
  BackClick = 'BackClick',
  CloseProfile = 'CloseProfile',
  OpenFeedback = 'OpenFeedback',
  ClassicRoleLibrary = 'ClassicRoleLibrary',
  MoreFaq = 'MoreFaq',
  OpenFaq = 'OpenFaq',
  NoRoleContent = 'NoRoleContent',
  NoCareerPathContent = 'NoCareerPathContent',
}

export enum EventName {
  NavigateToDisciplinePage = 'NavigateToDisciplinePage',
  NavigateToRolePage = 'NavigateToRolePage',
  OpenProfileTaskModule = 'OpenProfileTaskModule',
  UserSawTBD = 'UserSawTBD',
}
